export const baseUrl = "https://api.giftr.com.sg"
export const token = localStorage.getItem("token")